import { SVGProps } from 'react'

const CookiesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11956_138267)">
        <path
          d="M7.125 8.25C7.74632 8.25 8.25 7.74632 8.25 7.125C8.25 6.50368 7.74632 6 7.125 6C6.50368 6 6 6.50368 6 7.125C6 7.74632 6.50368 8.25 7.125 8.25Z"
          fill="#1A1E3D"
        />
        <path
          d="M13.875 2.25C14.4963 2.25 15 1.74632 15 1.125C15 0.50368 14.4963 0 13.875 0C13.2537 0 12.75 0.50368 12.75 1.125C12.75 1.74632 13.2537 2.25 13.875 2.25Z"
          fill="#1A1E3D"
        />
        <path
          d="M16.125 6C16.7463 6 17.25 5.49632 17.25 4.875C17.25 4.25368 16.7463 3.75 16.125 3.75C15.5037 3.75 15 4.25368 15 4.875C15 5.49632 15.5037 6 16.125 6Z"
          fill="#1A1E3D"
        />
        <path
          d="M7.125 12C7.74632 12 8.25 11.4963 8.25 10.875C8.25 10.2537 7.74632 9.75 7.125 9.75C6.50368 9.75 6 10.2537 6 10.875C6 11.4963 6.50368 12 7.125 12Z"
          fill="#1A1E3D"
        />
        <path
          d="M10.875 12C11.4963 12 12 11.4963 12 10.875C12 10.2537 11.4963 9.75 10.875 9.75C10.2537 9.75 9.75 10.2537 9.75 10.875C9.75 11.4963 10.2537 12 10.875 12Z"
          fill="#1A1E3D"
        />
        <path
          d="M17.9573 8.1405C17.9406 7.96711 17.8642 7.80491 17.741 7.68175C17.6178 7.55858 17.4556 7.48212 17.2823 7.4655C15.5495 7.29856 13.9288 6.53406 12.6979 5.30308C11.4671 4.07209 10.7028 2.45128 10.536 0.7185C10.5194 0.545111 10.4429 0.382914 10.3198 0.259747C10.1966 0.13658 10.0344 0.0601234 9.861 0.0435C9.57675 0.01575 9.29025 0 9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 8.70975 17.9843 8.42325 17.9573 8.1405ZM9 16.5C7.01088 16.5 5.10323 15.7098 3.6967 14.3033C2.29018 12.8968 1.5 10.9891 1.5 9C1.5 7.01088 2.29018 5.10322 3.6967 3.6967C5.10323 2.29018 7.01088 1.5 9 1.5H9.1275C9.4398 3.34182 10.3172 5.04091 11.6382 6.36186C12.9591 7.6828 14.6582 8.56021 16.5 8.8725C16.5 8.91525 16.5 8.95725 16.5 9C16.4978 10.9885 15.7069 12.8948 14.3009 14.3009C12.8948 15.7069 10.9885 16.4978 9 16.5Z"
          fill="#1A1E3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_11956_138267">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CookiesIcon
